/**
 * UnassignDialog (wandering profile) — confirm before unassigning + deactivating.
 *
 * Mirrors the Wandering tab's unassign confirmation on DevicesPage:
 * fires `unassignDevices()` which sets is_active = false, resident_id = null,
 * area_id = null on the device.
 */

const UnassignDialog = ({ deviceName, residentName, onClose, onConfirm, saving }) => {
  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div
          className="pp-dialog__header"
          style={{ padding: 'var(--space-4) var(--space-5)', borderBottom: '1px solid var(--color-border)' }}
        >
          <h3 style={{ margin: 0, fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-text-heading)' }}>
            Unassign Wandering Device
          </h3>
        </div>
        <div className="pp-dialog__body" style={{ padding: 'var(--space-5)' }}>
          <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
            Unassign <strong>{deviceName || 'this device'}</strong>
            {residentName ? <> from <strong>{residentName}</strong></> : null}? The badge will become
            inactive and will not generate alerts until it's reassigned.
          </p>
        </div>
        <div
          className="pp-dialog__footer"
          style={{ padding: 'var(--space-4) var(--space-5)', display: 'flex', justifyContent: 'flex-end', gap: 'var(--space-3)', borderTop: '1px solid var(--color-border)' }}
        >
          <button type="button" className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button type="button" className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
            {saving ? 'Unassigning…' : 'Unassign'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnassignDialog;
